// Shared validation helpers for Settings forms.

export const CA_POSTAL_RE = /^[A-Za-z]\d[A-Za-z][\s-]?\d[A-Za-z]\d$/;
export const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

export function validateCabinet(s) {
  const errs = {};
  if (s.email && !EMAIL_RE.test(s.email)) errs.email = "Format de courriel invalide";
  if (s.contact_email && !EMAIL_RE.test(s.contact_email)) errs.contact_email = "Format invalide";
  if (s.postal_code && !CA_POSTAL_RE.test(s.postal_code)) errs.postal_code = "Format A1A 1A1";
  if (s.phone) {
    const d = s.phone.replace(/\D/g, "");
    if (d.length < 10) errs.phone = "Telephone (min 10 chiffres)";
  }
  if (s.neq) {
    const d = s.neq.replace(/\D/g, "");
    if (d.length && d.length !== 10) errs.neq = "NEQ = 10 chiffres";
  }
  return errs;
}

export function validateInvoice(s) {
  const errs = {};
  if (s.invoice_next_number !== undefined && s.invoice_next_number !== "" && s.invoice_next_number !== null) {
    const n = parseInt(s.invoice_next_number);
    if (isNaN(n) || n < 1 || n > 9999999) errs.invoice_next_number = "Entier entre 1 et 9 999 999";
  }
  if (s.invoice_prefix && s.invoice_prefix.length > 20) errs.invoice_prefix = "Max 20 caracteres";
  return errs;
}
